module.exports = __webpack_public_path__ + "img/3ds.e043234a.svg";